import ProtectionPlansStatic from './ProtectionPlansStatic';

export default ProtectionPlansStatic;
